import { useState, useRef } from 'react';
import styles from './ReviewGrid.module.scss';
import ReviewCard from '../components/reviewCard/ReviewCard';
import { Grid, Typography } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function ReviewGrid({ reviews }) {
  const [scroll, setScroll] = useState(false);
  const reviewsContainerRef = useRef(null);
  const handleScrollLeft = () => {
    setScroll(false);
    if (reviewsContainerRef.current) {
      reviewsContainerRef.current.scrollLeft -= 1000;
    }
  };
  const handleScrollRight = () => {
    setScroll(true);
    if (reviewsContainerRef.current) {
      reviewsContainerRef.current.scrollLeft += 1000;
    }
  };
  return (
    <div className={styles.reviewGridExtender}>
      <div className={styles.reviewGridContainer}>
        <div className={styles.reviewContainer}>
          <div className={styles.reviewTitleContainer}>
            <div className={styles.reviewTitleBox}>
              <Typography
                variant="h2"
                color="primary"
                className={styles.reviewTitle}
              >
                See How{' '}
                <Typography
                  variant="h2"
                  component={'span'}
                  className={styles.reviewTitleHash}
                >
                  Relief Factor
                </Typography>{' '}
                Has Helped Others
              </Typography>
            </div>
          </div>
          <div className={styles.reviewGridMainContainer}>
            {reviews.length > 3 && scroll && (
              <div
                className={styles.leftArrowContainer}
                onClick={handleScrollLeft}
              >
                <ArrowBackIcon className={styles.arrowIcon} />
              </div>
            )}
            <Grid
              container
              wrap="nowrap"
              className={styles.reviewCardsGridContainer}
              ref={reviewsContainerRef}
            >
              {reviews.map((review) => (
                <Grid item xl={4} sx={{ scrollSnapAlign: 'center' }}>
                  <div className={styles.reviewCardRow}>
                    <ReviewCard review={review} />
                  </div>
                </Grid>
              ))}
            </Grid>
            {reviews.length > 3 && !scroll && (
              <div
                className={styles.rightArrowContainer}
                onClick={handleScrollRight}
              >
                <ArrowForwardIcon className={styles.arrowIcon} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
